import React from 'react';
import {
  getIsFirstStep,
  getIsLastStep,
  useWizardService,
} from '@bingads-webui-react/wizard';
import { Stack } from '@fluentui/react';
import { NextButton, BackButton, CancelButton, SaveAndExitButton } from './buttons';

export const LiftMeasurementStepFooter = () => {
  const { state } = useWizardService();
  const isFirstStep = getIsFirstStep(state);
  const isLastStep = getIsLastStep(state);

  return (
    <Stack horizontal tokens={{ childrenGap: 16 }}>
      {isFirstStep && <NextButton />}
      {isLastStep && <BackButton />}
      {isLastStep && <SaveAndExitButton />}
      <CancelButton />
    </Stack>
  );
};
